import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function InternshipOfferEngineer() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <div className="stage-page">
        <div className="header-fill"></div>
        <article className="stage-article container">
          <header className="stage-header">
            <div className="stage-title-row">
              <span className="stage-icon" aria-hidden="true">💻</span>
              <h1 className="stage-title">
                {translate("stageEngineerTitle", language)}
              </h1>
            </div>
            <p className="stage-subtitle">
              {translate("stageEngineerSubtitle", language)}
            </p>
            <p className="stage-tags">
              SaaS — IA — {translate("stageEngineerTagMobile", language)}
            </p>
          </header>

          <div className="stage-contact stage-contact-bar">
            <p>
              Yoann Couillec — CTO & {translate("stageEngineerFounder", language)} YGALAAD
            </p>
            <a href="mailto:career@ygalaad.com">career@ygalaad.com</a>
          </div>

          <div className="stage-intro">
            <p>{translate("stageEngineerIntro1", language)}</p>
            <p>{translate("stageEngineerIntro2", language)}</p>
          </div>

          <section className="stage-section">
            <h2>{translate("stageEngineerContext", language)}</h2>
            <ul>
              <li>{translate("stageEngineerContext1", language)}</li>
              <li>{translate("stageEngineerContext2", language)}</li>
              <li>{translate("stageEngineerContext3", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageEngineerMissions", language)}</h2>
            <ul>
              <li>{translate("stageEngineerMission1", language)}</li>
              <li>{translate("stageEngineerMission2", language)}</li>
              <li>{translate("stageEngineerMission3", language)}</li>
              <li>{translate("stageEngineerMission4", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageEngineerProfile", language)}</h2>
            <ul>
              <li>{translate("stageEngineerProfile1", language)}</li>
              <li>{translate("stageEngineerProfile2", language)}</li>
              <li>{translate("stageEngineerProfile3", language)}</li>
              <li>{translate("stageEngineerProfile4", language)}</li>
              <li>{translate("stageEngineerProfile5", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageEngineerBenefits", language)}</h2>
            <ul>
              <li>{translate("stageEngineerBenefit1", language)}</li>
              <li>{translate("stageEngineerBenefit2", language)}</li>
              <li>{translate("stageEngineerBenefit3", language)}</li>
              <li>{translate("stageEngineerBenefit4", language)}</li>
              <li>{translate("stageEngineerBenefit5", language)}</li>
            </ul>
          </section>

          <section className="stage-section stage-practical">
            <h2>{translate("stageEngineerPractical", language)}</h2>
            <ul>
              <li>{translate("stageEngineerPractical1", language)}</li>
              <li>{translate("stageEngineerPractical2", language)}</li>
              <li>
                {translate("stageEngineerPractical5", language)}{" "}
                <a href="mailto:career@ygalaad.com">career@ygalaad.com</a>
              </li>
            </ul>
          </section>

          <div className="stage-cta">
            <a href="mailto:career@ygalaad.com" className="stage-cta-btn">
              {translate("stageEngineerApply", language)}
            </a>
            <a
              href="/pdf/internship_engineering.pdf"
              className="stage-other-link"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate("stageEngineerDownloadPdf", language)}
            </a>
            <Link
              to={`/${language}/stage-sales-marketing`}
              className="stage-other-link"
            >
              {translate("stageOtherOffer", language)}
            </Link>
          </div>
        </article>
      </div>
      <Footer />
    </>
  );
}

export default InternshipOfferEngineer;
